// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDependentInfoDto } from './IDependentInfoDto';
import {
    IDependentInfoDtoFromJSON,
    IDependentInfoDtoFromJSONTyped,
    IDependentInfoDtoToJSON,
    IDependentInfoDtoToJSONTyped,
} from './IDependentInfoDto';
import type { IPhoneInfoDto } from './IPhoneInfoDto';
import {
    IPhoneInfoDtoFromJSON,
    IPhoneInfoDtoFromJSONTyped,
    IPhoneInfoDtoToJSON,
    IPhoneInfoDtoToJSONTyped,
} from './IPhoneInfoDto';
import type { IAddressInfoDto } from './IAddressInfoDto';
import {
    IAddressInfoDtoFromJSON,
    IAddressInfoDtoFromJSONTyped,
    IAddressInfoDtoToJSON,
    IAddressInfoDtoToJSONTyped,
} from './IAddressInfoDto';

/**
 * 
 * @export
 * @interface IPersonInfoDto
 */
export interface IPersonInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IPersonInfoDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPersonInfoDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPersonInfoDto
     */
    preferred_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPersonInfoDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPersonInfoDto
     */
    middle_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPersonInfoDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPersonInfoDto
     */
    suffix?: string;
    /**
     * 
     * @type {string}
     * @memberof IPersonInfoDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IPersonInfoDto
     */
    gender_type?: IPersonInfoDtoGenderTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPersonInfoDto
     * @deprecated
     */
    birth_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPersonInfoDto
     */
    local_date_birth_on?: Date;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IPersonInfoDto
     */
    preferred_phone?: IPhoneInfoDto;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IPersonInfoDto
     */
    additional_phone?: IPhoneInfoDto;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IPersonInfoDto
     */
    employer_provided_phone?: IPhoneInfoDto;
    /**
     * 
     * @type {IPhoneInfoDto}
     * @memberof IPersonInfoDto
     */
    phone?: IPhoneInfoDto;
    /**
     * 
     * @type {string}
     * @memberof IPersonInfoDto
     */
    employer_provided_email?: string;
    /**
     * 
     * @type {string}
     * @memberof IPersonInfoDto
     */
    employee_provided_email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPersonInfoDto
     */
    is_employee_email_preferred?: boolean;
    /**
     * 
     * @type {Set<IDependentInfoDto>}
     * @memberof IPersonInfoDto
     */
    dependents?: Set<IDependentInfoDto>;
    /**
     * 
     * @type {Set<IAddressInfoDto>}
     * @memberof IPersonInfoDto
     */
    addresses?: Set<IAddressInfoDto>;
    /**
     * 
     * @type {number}
     * @memberof IPersonInfoDto
     */
    organization_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPersonInfoDto
     */
    is_employee_email_verified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPersonInfoDto
     */
    is_employer_email_verified?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IPersonInfoDtoGenderTypeEnum {
    M = 'M',
    F = 'F',
    O = 'O'
}


/**
 * Check if a given object implements the IPersonInfoDto interface.
 */
export function instanceOfIPersonInfoDto(value: object): value is IPersonInfoDto {
    return true;
}

export function IPersonInfoDtoFromJSON(json: any): IPersonInfoDto {
    return IPersonInfoDtoFromJSONTyped(json, false);
}

export function IPersonInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPersonInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'preferred_name': json['preferred_name'] == null ? undefined : json['preferred_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'gender_type': json['gender_type'] == null ? undefined : json['gender_type'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'local_date_birth_on': json['local_date_birth_on'] == null ? undefined : (new Date(json['local_date_birth_on'])),
        'preferred_phone': json['preferred_phone'] == null ? undefined : IPhoneInfoDtoFromJSON(json['preferred_phone']),
        'additional_phone': json['additional_phone'] == null ? undefined : IPhoneInfoDtoFromJSON(json['additional_phone']),
        'employer_provided_phone': json['employer_provided_phone'] == null ? undefined : IPhoneInfoDtoFromJSON(json['employer_provided_phone']),
        'phone': json['phone'] == null ? undefined : IPhoneInfoDtoFromJSON(json['phone']),
        'employer_provided_email': json['employer_provided_email'] == null ? undefined : json['employer_provided_email'],
        'employee_provided_email': json['employee_provided_email'] == null ? undefined : json['employee_provided_email'],
        'is_employee_email_preferred': json['is_employee_email_preferred'] == null ? undefined : json['is_employee_email_preferred'],
        'dependents': json['dependents'] == null ? undefined : (new Set((json['dependents'] as Array<any>).map(IDependentInfoDtoFromJSON))),
        'addresses': json['addresses'] == null ? undefined : (new Set((json['addresses'] as Array<any>).map(IAddressInfoDtoFromJSON))),
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'is_employee_email_verified': json['is_employee_email_verified'] == null ? undefined : json['is_employee_email_verified'],
        'is_employer_email_verified': json['is_employer_email_verified'] == null ? undefined : json['is_employer_email_verified'],
    };
}

export function IPersonInfoDtoToJSON(json: any): IPersonInfoDto {
    return IPersonInfoDtoToJSONTyped(json, false);
}

export function IPersonInfoDtoToJSONTyped(value?: IPersonInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'employee_id': value['employee_id'],
        'preferred_name': value['preferred_name'],
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'suffix': value['suffix'],
        'ssn': value['ssn'],
        'gender_type': value['gender_type'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString()),
        'local_date_birth_on': value['local_date_birth_on'] == null ? undefined : ((value['local_date_birth_on']).toISOString().substring(0,10)),
        'preferred_phone': IPhoneInfoDtoToJSON(value['preferred_phone']),
        'additional_phone': IPhoneInfoDtoToJSON(value['additional_phone']),
        'employer_provided_phone': IPhoneInfoDtoToJSON(value['employer_provided_phone']),
        'phone': IPhoneInfoDtoToJSON(value['phone']),
        'employer_provided_email': value['employer_provided_email'],
        'employee_provided_email': value['employee_provided_email'],
        'is_employee_email_preferred': value['is_employee_email_preferred'],
        'dependents': value['dependents'] == null ? undefined : (Array.from(value['dependents'] as Set<any>).map(IDependentInfoDtoToJSON)),
        'addresses': value['addresses'] == null ? undefined : (Array.from(value['addresses'] as Set<any>).map(IAddressInfoDtoToJSON)),
        'organization_id': value['organization_id'],
        'is_employee_email_verified': value['is_employee_email_verified'],
        'is_employer_email_verified': value['is_employer_email_verified'],
    };
}

